<div class="details-data-placeholder">
  <ng-content></ng-content>
</div>
